module.exports = __webpack_public_path__ + "img/bg@3x.c379fafb.png";